















































































import { Vue, Component, Prop } from "vue-property-decorator";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import { LearningGroup as ILearningGroup } from "@/api-v2/learning-group/models";

@Component({ components: { CustomTableCol, CustomTableItem } })
export default class LearningGroupTableItem extends Vue {
  @Prop() group!: ILearningGroup;
  isShowStudents: boolean = false;
}
